// Disable COLORS
// <ul v-if="has_colors" class="product-item__colors list--unstyled">
//   <li v-for="color in unique_colors" class="product-item__color" :title="color">
//     <span :style="{ 'background-color': color, 'background-image': 'url(' + bg_colors[color] + ')' }"></span>
//     </li>
//     </ul>
//  <figure class="product-item__figure">
//       </figure>
// 		<button class="swym-button swym-add-to-wishlist-view-product" data-with-epi="true" :data-variant-id="product.shopify_variants[0].variant_id" data-swaction="addToWishlist" :data-product-id="product.product_id"></button>


export default {
    name: 'vue-product',
    props: ['product', 'collection_url'],
    delimiters: ['$[', ']'], 
    template: `
        <div :id="product.product_id" class="collection__item product-item text-center here" data-controller="addtocart">
        
		<div v-if="isOnSale()" class="sale-item icn">
          <div class="product-tag product-tag--absolute" aria-hidden="true">
            <div id="burst-12" class="">
              <span>
             	 Save $[save]%
              </span>
            </div>
          </div>
        </div>


    



        <a :href="product.link">
<span class="iWishAddColl iwishcheck" href="#" :data-variant="product.shopify_variants[0].variant_id" :data-product="product.product_id" :data-pTitle="product.title"></span>
          <div class="product-item__image-wrapper">
          	<img :src="main_image" class="product-item__image" :alt="product.title">
          </div>
        </a>
     
		<div class="product-item__details">

            <a :href="product.link">

              <h3>$[ product.title ]</h3>
              <div class="product-card__brand">$[product.vendor]</div>

            </a>

			<div v-if="product.list_price > 0">
              <p class="price">
				<span>
				  <span style="color: red;" class="money price-target" data-target="addtocart.price">$[ Number(product.price).toFixed(2) ]</span> /
                  <span class="money price-old" >$[ Number(product.list_price).toFixed(2) ]</span>
				  | <span> AED</span>
				</span>

				<input type="hidden" class="original-price" data-target="addtocart.originalPrice" v-model="product.price">
              </p>
			</div>

			<div v-else>
              <p class="price">

                <span>
	                <span class="money price-target" data-target="addtocart.price" 
    		            data-currency="AED" :data-currency-aed="reg_price">$[reg_price]</span>
					<span> AED</span>
                </span>

                <input type="hidden" class="original-price" data-target="addtocart.originalPrice" v-model="product.price">
              </p>
			</div>
			
            <div class="prod_unit_section_small">
              <div class="prod_unit_tp">
                <span class="prod_unt_star">*</span> 
                $[ uvartitle ]
              </div>
            </div>
			
			
		</div>


      	  <div class="product-data">
            <div class="grid-view-item__price-qty">

              <input type="hidden" class="stock" data-target="addtocart.stock" v-model="inventory_qty ">
              <input type="hidden" class="variant" data-target="addtocart.variant" v-model="product.add_to_cart_id">

              <button class="qty-minus" data-action="click->addtocart#decrement">-</button>


              <span v-if="unit == 'kg'">
                  <input class="current-qty" type="number" readonly disabled data-target="addtocart.qty_gram" value="0" placeholder="0.25" name="quantity">
                  <span class="kg">Kg</span>

                  <input class="current-qty" disabled readonly 
                     type="hidden" data-target="addtocart.qty" value="0" name="quantity" >
              </span>


              <input v-else class="current-qty" disabled readonly 
                     type="number" data-target="addtocart.qty" value="0" name="quantity" >

              <button class="qty-plus" data-action="click->addtocart#increment">
                 <i class="ion-plus-round"></i>
              </button>

            </div>
          </div>

    	<div class="product-single__description rte" v-html="approx"></div>

      </div>
    `,

    data: function () {
      return {
        available: true,
        outstock: false,
        inStock: 0,
        secondImage: '',
        unit: '',
        inventory_qty: 100
      }
    },

    created: function () {
     
    },

    mounted: function () {
      if(window._swat) window._swat.initializeActionButtons("#" + this.product.product_id + " .product-item__details");
    },

    beforeDestroy: function () {

    },
  
    computed: {
      main_image() {
        return this.imgURL(this.product.shopify_images[0], 'medium');
      },

      reg_price() {
        return Number(this.product.price).toFixed(2);
      },
      
      approx() {
        var desc = this.product.description.split("(")[0]
        var desc = desc + " (approx)"

		return desc;
      },
      
      save() {
        return Math.round(((this.product.list_price - this.product.price) * 100) / this.product.list_price).toFixed(0);
      },
      
      uvartitle() {
        var vm = this;
        var uv = vm.product.shopify_variants[0].options[Object.keys(vm.product.shopify_variants[0].options)[0]].toLowerCase(); 
       
        if (uv.includes('kg')) {
            var unit = 'Starts at 0.25KG "250 grams"';
          	vm.unit = 'kg';
            return unit;
          
        } else if (uv.includes('piece')) {
            var unit = 'Per Piece';
			return unit;
        } else if (uv.includes('packet')) {
           var unit = 'Per Pack';
			return unit;
        } else if (uv.includes('case')) {
           var unit = 'Per Case';
			return unit;
        } else if (uv.includes('pot')) {
           var unit = 'Per Pot';
			return unit;
        } else if (uv.includes('bunch')) {
           var unit = 'Per Bunch';
			return unit;
        } else if (uv.includes('bag')) {
           var unit = 'Per Bag';
			return unit;
        } else if (uv.includes('set')) {
           var unit = 'Per Set';
			return unit;
        } else if (uv.includes('jar')) {
           var unit = 'Per Jar';
			return unit;
        } else if (uv.includes('card')) {
           var unit = 'Per dirhams';
		   return unit;
        }
        
      }
    },

    methods: {
      imgURL(src, size) {
        // remove any current image size then add the new image size
        return src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
          return '_'+size+match;
        })
        ;
      },
      
      
      isOnSale() {
        if (this.product.price < this.product.list_price ) {
          return true
        } else {
          return false;
        }
      },
    },

};

